export default __webpack_public_path__ + "static/media/Chirag Kathrani.08666dcf.jpg";